import { AuthLayout } from '../components/AuthLayout';
import ForgotPasswordForm from './ForgotPasswordForm';

const ForgotPassword = () => (
  <AuthLayout>
    <ForgotPasswordForm />
  </AuthLayout>
);

export default ForgotPassword;
